export default __webpack_public_path__ + "static/media/zapier.54262094.svg";